// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error-msg{position:relative;top:50%;left:25%}.error-msg details{width:60%}", "",{"version":3,"sources":["webpack://./src/components/ErrorMsg.scss"],"names":[],"mappings":"AACA,WACE,iBAAA,CACA,OAAA,CACA,QAAA,CAEA,mBACE,SAAA","sourcesContent":["\n.error-msg {\n  position: relative;\n  top: 50%;\n  left: 25%;\n\n  details {\n    width: 60%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
